<template>
    <div class="product-form__images flex flex-wrap">
        <template v-if="cropperSrc">
            <cropper
                :src="cropperSrc"
                :mime="cropperMime"
                @imgCropped="onImgCropped($event)"
            />
        </template>

        <template v-else>
            <div
                v-for="image in displayedImages"
                :key="image.ItemImageID"
                class="product-form__img-wrap js-upload-img-wrap"
            >
                <div
                    class="product-form__img js-upload-img uploaded"
                    :style="{ 'background-image': `url('${image.url}')` }"
                ></div>
                <button
                    type="button"
                    class="cabinet-btn--remove-img"
                    @click.prevent="deleteImage(image.ItemImageID)"
                ></button>
            </div>

            <div class="product-form__img-wrap js-upload-img-wrap">
                <div
                    class="product-form__img js-upload-img"
                    @click="onAddImage()"
                ></div>
                <input
                    ref="imageFile"
                    type="file"
                    accept="image/jpeg,image/png"
                    class="hide"
                    @change="uploadImage"
                />
                <button
                    type="button"
                    class="cabinet-btn--remove-img hide"
                ></button>
            </div>
        </template>
    </div>
</template>

<script>
import Cropper from '@/components/Elements/Cropper'

export default {
    name: 'EditImages',
    components: { Cropper },
    props: {
        initialImages: {
            type: Array,
            default: function() {
                return []
            }
        }
    },
    data() {
        return {
            images: [],
            cropperSrc: '',
            cropperMime: ''
        }
    },
    computed: {
        displayedImages() {
            return this.images.filter(image => image.url)
        },
        needSaveImages() {
            return this.images.filter(image => image.needSave)
        }
    },
    watch: {
        initialImages: {
            handler: function(val) {
                this.images = this.initialImages
            },
            deep: true
        },
        images: {
            handler: function(val) {
                this.$emit('onImagesChange', {
                    images: [...this.images],
                    displayedImages: [...this.displayedImages],
                    needSaveImages: [...this.needSaveImages]
                })
            },
            deep: true
        }
    },
    methods: {
        onAddImage() {
            this.$refs.imageFile.click()
        },
        uploadImage(e) {
            const image = e.target.files[0]
            const reader = new FileReader()
            reader.readAsDataURL(image)
            reader.onload = () => {
                window.$('#productImagesBtn').addClass('hidden')
                this.cropperSrc = reader.result
                this.cropperMime = e.target.files[0].type
            }
        },
        onImgCropped(dataUrl) {
            this.images.push({
                needSave: true,
                ItemImageID: Date.now(),
                url: dataUrl
            })

            this.cropperSrc = ''
            window.$('#productImagesBtn').removeClass('hidden')
        },
        deleteImage(id) {
            let img = this.images.find(image => image.ItemImageID == id)
            let index = this.images.findIndex(image => image.ItemImageID == id)

            if (img.needSave) {
                //удаляем изображения, которые добавили на фронте не сохранив на бэке
                this.images.splice(index, 1)
            } else {
                this.images[index] = {
                    ...img,
                    url: null, //обнуляем содержимое тем изображениям, что пришли с бэка
                    needSave: true
                }
                this.images = [...this.images]
            }
        }
    }
}
</script>
